export const diatonicChordLists: {
  [key: string]: {
    [degree: string]: string;
  };
} = {
  C: {
    1: 'C',
    2: 'Dm',
    3: 'Em',
    4: 'F',
    5: 'G',
    6: 'Am',
    7: 'Bm',
  },
  G: {
    1: 'G',
    2: 'Am',
    3: 'Bm',
    4: 'C',
    5: 'D',
    6: 'Em',
    7: 'F#m',
  },
  D: {
    1: 'D',
    2: 'Em',
    3: 'F#m',
    4: 'G',
    5: 'A',
    6: 'Bm',
    7: 'C#m',
  },
  A: {
    1: 'A',
    2: 'Bm',
    3: 'C#m',
    4: 'D',
    5: 'E',
    6: 'F#m',
    7: 'G#m',
  },
  E: {
    1: 'E',
    2: 'F#m',
    3: 'G#m',
    4: 'A',
    5: 'B',
    6: 'C#m',
    7: 'D#m',
  },
  B: {
    1: 'B',
    2: 'C#m',
    3: 'D#m',
    4: 'E',
    5: 'F#',
    6: 'G#m',
    7: 'A#m',
  },
  'F#': {
    1: 'F#',
    2: 'G#m',
    3: 'A#m',
    4: 'B',
    5: 'C#',
    6: 'D#m',
    7: 'Fm',
  },
  F: {
    1: 'F',
    2: 'Gm',
    3: 'Am',
    4: 'Bb',
    5: 'C',
    6: 'Dm',
    7: 'Em',
  },
  Bb: {
    1: 'Bb',
    2: 'Cm',
    3: 'Dm',
    4: 'Eb',
    5: 'F',
    6: 'Gm',
    7: 'Am',
  },
  Eb: {
    1: 'Eb',
    2: 'Fm',
    3: 'Gm',
    4: 'Ab',
    5: 'Bb',
    6: 'Cm',
    7: 'Dm',
  },
  Ab: {
    1: 'Ab',
    2: 'Bbm',
    3: 'Cm',
    4: 'Db',
    5: 'Eb',
    6: 'Fm',
    7: 'Gm',
  },
  Db: {
    1: 'Db',
    2: 'Ebm',
    3: 'Fm',
    4: 'G',
    5: 'A',
    6: 'Bbm',
    7: 'Cm',
  },
  Gb: {
    1: 'Gb',
    2: 'Abm',
    3: 'Bbm',
    4: 'Cb',
    5: 'Db',
    6: 'Ebm',
    7: 'Fm',
  },
};
